'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
module.exports = /*#__PURE__*/function () {
  function SymbolTreeNode() {
    _classCallCheck(this, SymbolTreeNode);
    this.parent = null;
    this.previousSibling = null;
    this.nextSibling = null;
    this.firstChild = null;
    this.lastChild = null;

    /** This value is incremented anytime a children is added or removed */
    this.childrenVersion = 0;
    /** The last child object which has a cached index */
    this.childIndexCachedUpTo = null;

    /** This value represents the cached node index, as long as
     * cachedIndexVersion matches with the childrenVersion of the parent */
    this.cachedIndex = -1;
    this.cachedIndexVersion = NaN; // NaN is never equal to anything
  }
  _createClass(SymbolTreeNode, [{
    key: "isAttached",
    get: function get() {
      return Boolean(this.parent || this.previousSibling || this.nextSibling);
    }
  }, {
    key: "hasChildren",
    get: function get() {
      return Boolean(this.firstChild);
    }
  }, {
    key: "childrenChanged",
    value: function childrenChanged() {
      /* jshint -W016 */
      // integer wrap around
      this.childrenVersion = this.childrenVersion + 1 & 0xFFFFFFFF;
      this.childIndexCachedUpTo = null;
    }
  }, {
    key: "getCachedIndex",
    value: function getCachedIndex(parentNode) {
      // (assumes parentNode is actually the parent)
      if (this.cachedIndexVersion !== parentNode.childrenVersion) {
        this.cachedIndexVersion = NaN;
        // cachedIndex is no longer valid
        return -1;
      }
      return this.cachedIndex; // -1 if not cached
    }
  }, {
    key: "setCachedIndex",
    value: function setCachedIndex(parentNode, index) {
      // (assumes parentNode is actually the parent)
      this.cachedIndexVersion = parentNode.childrenVersion;
      this.cachedIndex = index;
    }
  }]);
  return SymbolTreeNode;
}();